import React, {useState, useRef, useEffect} from "react";
import {InputText} from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import '../../css/DataTableDemo.css'
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {TabPanel, TabView} from "primereact/tabview";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {Tag} from "primereact/tag";
import {confirmDialog} from "primereact/confirmdialog";
import {Panel} from "primereact/panel";
import {Knob} from "primereact/knob";
import {InputNumber} from "primereact/inputnumber";
import axios from "axios";


const Reservation = props => {
    const [globalFilter1, setGlobalFilter1] = useState('');
    const sss_add_role = localStorage.getItem('sss_add') ? true : false;
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [allReservations, setAllReservations] = useState([]);
    const [approvedReservations, setApprovedReservations] = useState([]);
    const [pendingApprovalReservations, setPendingApprovalReservations] = useState([]);
    const [rejectedReservations, setRejectedReservations] = useState([]);
    const [expiredReservations, setExpiredReservations] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [rejectDialog, setRejectDialog] = useState(false);
    const [reservationRejectedDescription, SetReservationRejectedDescription] = useState("");
    const [applicationID, setApplicationID] = useState(null);
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [descriptionDialogContent, setDescriptionDialogContent] = useState("");
    const [maxRezTime, setMaxRezTime] = useState(0);
    const [maxModülRezTime, setMaxModülRezTime] = useState(0);


    useEffect(() => {

            getAllReservations();
            getApprovedReservations();
            getPendindApprovalReservations();
            getRejectReservations();
            getExpiredReservations();
            resultMaxRez();
        }
        ,
        []
    )
    ;
    const getAllReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/reservations/all", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;


                        if (data.result) {
                            setAllReservations(data.reservation_list);


                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getApprovedReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/reservations/approved", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApprovedReservations(data.reservation_list);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getPendindApprovalReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/reservations/pending_approval", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;

                        if (data.result) {
                            setPendingApprovalReservations(data.reservation_list);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getRejectReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/reservations/rejected", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;

                        if (data.result) {
                            setRejectedReservations(data.reservation_list);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getExpiredReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/reservations/expired", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;

                        if (data.result) {
                            setExpiredReservations(data.reservation_list);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }


    const submit = (resvID, startTime, finishTime) => {


        const obj = {
            resvID: resvID,
            startTime: startTime,
            finishTime: finishTime


        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);

            fetch("/api/allocation/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {

                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {


                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                            getAllReservations();
                            getApprovedReservations();
                            getPendindApprovalReservations();
                            getExpiredReservations();
                            getRejectReservations();
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }


    }

    const reject = () => {
        if (reservationRejectedDescription !== "") {
            const obj = {
                resvID: applicationID,
                reservationRejectedDescription: reservationRejectedDescription,


            };

            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");

            if (token) {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);

                fetch("/api/reject/", {headers, method: "PUT", body})
                    .then(res => {
                        if (res.status < 500) {

                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;
                            if (data.result) {
                                setRejectDialog(false)
                                SetReservationRejectedDescription('')
                                showSuccess(data.message);
                                getAllReservations();
                                getApprovedReservations();
                                getPendindApprovalReservations();
                                getRejectReservations();
                                getExpiredReservations();
                            } else {
                                showError(data.message);
                            }
                        } else if (res.status === 401 || res.status === 403) {

                            throw res.data;
                        }
                    })

            }


        } else {
            showError("Rezervasyon iptal açıklaması boş bırakılamaz!");

        }

    }
    const rejectDialogDisplay = (application_id) => {
        setApplicationID(application_id);
        setRejectDialog(true)
    }

    const actionTemplate2 = (rowData) => {
        let status = rowData.sact_id
        if (status === 1) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Bekliyor" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 2) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 3) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş" rounded/>


                </React.Fragment>


            </div>;

        }

    }
    const actionTemplate3 = (rowData) => {
        let status = rowData.sact_id
        if (status === 1) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Verme Süresi Doldu" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 2) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış ve Süresi Dolmuş" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 3) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş Süresi Dolmuş" rounded/>


                </React.Fragment>


            </div>;

        }

    }
    const descriptionDialogOnDisplay = (content) => {
        setDescriptionDialog(true);
        setDescriptionDialogContent(content);
    }
    const descriptionDialogOnHide = () => {
        setDescriptionDialogContent("");
        setDescriptionDialog(false);
    }


    const descriptionBody = (rowData) => {
        return (
            <React.Fragment>
                <div align="center">
                    <div className="p-grid">
                        <div className="p-col-12" align="center">
                            <span className="p-column-title">{rowData.resv_controldescription}</span>
                        </div>
                        <div className="p-col-12" align="center" style={{wordBreak: "break-all"}}>
                            {rowData.resv_controldescription
                                ?
                                rowData.resv_controldescription.length > 20
                                    ?
                                    <div>
                                        {rowData.resv_controldescription.substring(0, 20) + "..."}
                                        <Button label="Devamını Oku"
                                                onClick={(e) => descriptionDialogOnDisplay(rowData.resv_controldescription)}
                                                className="p-button-text"
                                        />
                                    </div>
                                    :
                                    rowData.resv_controldescription
                                :
                                <span>-</span>
                            }
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }


    const confirmDeleteServer = (resv_id, resv_starttime, resv_finishtime) => {
        confirmDialog({
            message: 'İşlem sonunda rezervasyon alınmış olacak. Onaylıyor musunuz?',
            icon: 'pi pi-info-circle',
            header: 'Rezervasyon Onayı',
            acceptClassName: 'p-button-success',
            acceptLabel: 'Evet',
            acceptIcon: 'pi pi-check',
            rejectLabel: 'Hayır',
            rejectIcon: 'pi pi-times',
            accept() {
                submit(resv_id, resv_starttime, resv_finishtime)

            },
            reject() {

            }
        });
    }


    const actionTemplate = (rowData) => {
        return <div>
            <React.Fragment>


                <Button icon="pi pi-check" className=" p-button-success p-mr-2" tooltip="Onayla"

                        onClick={() => confirmDeleteServer(rowData.resv_id, rowData.resv_starttime, rowData.resv_finishtime)}
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


                <Button icon="pi pi-times" className=" p-button-danger"

                        onClick={() => rejectDialogDisplay(rowData.resv_id, rowData.resv_starttime, rowData.resv_finishtime)}
                        tooltip="Reddet"
                        tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                />


            </React.Fragment>


        </div>;
    }

    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    const getInstBody = (rowData) => {
        if (rowData['resv_institution']) {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                {rowData['resv_institution']}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        } else if (rowData['usr_user__user_inst']) {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                {rowData['usr_user__user_inst']}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div>
                        <span>-</span>
                    </div>
                </React.Fragment>
            )
        }


    }

    const getController = (rowData) => {
        if (rowData['resv_controller']) {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                {rowData['resv_controller']}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div>
                        <span>-</span>
                    </div>
                </React.Fragment>
            )
        }


    }
    const modelegitimTemplate = () => {

        return (
            <div align="center">

                <h6><b>Maksimum Seçilebilecek Süreleri Belirle</b>
                </h6>


            </div>
        )
    }
    const submitRezTime = () => {
        const obj = {
            maxRezTime: maxRezTime,
            maxModülRezTime: maxModülRezTime
        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            fetch("/api/max-rez-time/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            showSuccess(data.message);

                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })

        }


    }
    const resultMaxRez = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/max-rez-time/', {"headers": headers})
            .then(res => {
                let limit = res.data.result
                setMaxRezTime(limit['maxRezTime'])
                setMaxModülRezTime(limit['maxModülRezTime'])
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })

            .then(res => {

                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }


    if (sss_add_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <Panel toggleable header={modelegitimTemplate}>
                            <div className="p-grid">
                                <div className="p-col-6">
                                    <h5>Sunucu Rezervasyonu için Seçilebilecek Maksimum Süreyi Belirle (Ay)</h5>
                                    {/*<Knob value={megValue} onChange={(e) => setMegValue(e.value)} valueColor="#689F38"*/}
                                    {/*      min={0} max={12}/>*/}
                                    <InputNumber id="vertical" mode="decimal" showButtons
                                                 value={maxRezTime}
                                                 onValueChange={(e) => setMaxRezTime(e.value)}
                                                 buttonLayout="vertical" style={{width: '4rem'}}
                                        // min={1} max={12}
                                                 decrementButtonClassName="p-button-secondary"
                                                 incrementButtonClassName="p-button-secondary"
                                                 incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
                                </div>
                                <div className="p-col-6">
                                    <h5>Portal Başvurusu için Seçilebilecek Maksimum Süreyi Belirle (Ay)</h5>
                                    <InputNumber id="vertical" mode="decimal" showButtons
                                                 value={maxModülRezTime}
                                                 onValueChange={(e) => setMaxModülRezTime(e.value)}
                                                 buttonLayout="vertical" style={{width: '4rem'}}
                                                 decrementButtonClassName="p-button-secondary"
                                                 incrementButtonClassName="p-button-secondary"
                                        // min={1} max={12}
                                                 incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
                                </div>
                                <div className="p-col-2" style={{marginInline: 'auto'}}>
                                    <Button label="Onayla" className="p-button-secondary"
                                            onClick={submitRezTime}
                                    />
                                </div>

                                <div>


                                </div>
                                {/*<div>*/}
                                {/*    <Button label="Onayla" className="p-button-rounded p-button-success"*/}
                                {/*        // onClick={confirm1}*/}
                                {/*    />*/}

                                {/*</div>*/}
                            </div>
                        </Panel>
                    </div>
                </div>

                <Spinner loadingState={loadingState}/>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Tümü">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <Dialog visible={descriptionDialog}
                                        onHide={descriptionDialogOnHide}
                                        header="İptal Nedeni"
                                        style={{width: '75%'}}
                                        dismissableMask
                                >
                                    <div className="p-grid">
                                        <div className="p-col-12">
                                            {descriptionDialogContent}
                                        </div>
                                    </div>
                                </Dialog>
                                <DataTable
                                    value={allReservations}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}

                                >
                                    <Column
                                        field={'resv_id'}
                                        header="No"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        body={actionTemplate2}
                                        header="Onay Durumu"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        field={'flav__flav_gpucount'}
                                        header="GPU"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_cpucount'}
                                        header="CPU"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_ramsize'}
                                        header="RAM"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_disksize'}
                                        header="DISK"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'usr_user__user_username'}
                                        header="Talepte Bulunan"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        header="Kontrol Eden"
                                        body={getController}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        header="Talepte Bulunanın Kurumu"
                                        body={getInstBody}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />

                                    {/*<Column*/}
                                    {/*    field={'resv_reason'}*/}
                                    {/*    header="Rezervasyon Açıklaması"*/}
                                    {/*    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}*/}

                                    {/*>*/}

                                    {/*</Column>*/}
                                    <Column
                                        field={'resv_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        header="İptal Nedeni"
                                        body={descriptionBody}
                                        style={{
                                            textAlign: 'center', width: '5.5em', wordBreak: 'break-all'
                                        }}

                                    />


                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header={<div style={{color: 'red'}}>Onay Bekleyen Rezervasyonlar
                        ({pendingApprovalReservations.length})</div>}>
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <Dialog visible={rejectDialog}
                                        onHide={() => {
                                            setRejectDialog(false);
                                            SetReservationRejectedDescription('');
                                        }}
                                        header="Rezervasyonu İptal Et"
                                        style={{width: '75%'}}
                                        maximizable
                                        dismissableMask
                                >
                                    <div className="p-grid">
                                        <div className="p-col-12">
                                            <div className="p-field p-md-4 p-mt-5" style={{width: '100%'}}>
                                <span className="p-float-label">
                                    <InputTextarea id="rejectedDescription" value={reservationRejectedDescription}
                                                   onChange={(e) => SetReservationRejectedDescription(e.target.value)}
                                                   rows={3}
                                                   style={{width: '100%'}}
                                    />
                                    <label htmlFor="rejectedDescription">Rezervasyon İptal Açıklaması</label>
                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12" align="right">
                                            <Button label="İptal Et"
                                                    className="p-button-danger"
                                                    icon="pi pi-times"
                                                    onClick={(e) => reject()}

                                            />
                                        </div>
                                    </div>
                                </Dialog>
                                <DataTable
                                    value={pendingApprovalReservations}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'resv_id'}
                                        header="No"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        body={actionTemplate2}
                                        header="Onay Durumu"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        field={'flav__flav_name'}
                                        header="Şablon Adı"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_gpucount'}
                                        header="GPU"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_cpucount'}
                                        header="CPU"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_ramsize'}
                                        header="RAM"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_disksize'}
                                        header="DISK"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'usr_user__user_username'}
                                        header="Talepte Bulunan"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        header="Talepte Bulunanın Kurumu"
                                        body={getInstBody}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'resv_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        body={actionTemplate}
                                        header="İşlevler"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                </DataTable>

                            </div>

                        </div>

                    </TabPanel>
                    <TabPanel header="Onaylanmış Rezervasyonlar">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={approvedReservations}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'resv_id'}
                                        header="No"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        body={actionTemplate2}
                                        header="Onay Durumu"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        field={'flav__flav_name'}
                                        header="Şablon Adı"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_gpucount'}
                                        header="GPU"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_cpucount'}
                                        header="CPU"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_ramsize'}
                                        header="RAM"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_disksize'}
                                        header="DISK"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'usr_user__user_username'}
                                        header="Talepte Bulunan"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        body={getController}
                                        header="Kontrol Eden"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        header="Talepte Bulunanın Kurumu"
                                        body={getInstBody}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />

                                    {/*<Column*/}
                                    {/*    field={'resv_reason'}*/}
                                    {/*    header="Rezervasyon Açıklaması"*/}
                                    {/*    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}*/}

                                    {/*>*/}

                                    {/*</Column>*/}
                                    <Column
                                        field={'resv_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel header="Reddedilen Rezervasyonlar">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={rejectedReservations}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'resv_id'}
                                        header="No"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        body={actionTemplate2}
                                        header="Onay Durumu"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />


                                    <Column
                                        field={'flav__flav_name'}
                                        header="Şablon Adı"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_gpucount'}
                                        header="GPU"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_cpucount'}
                                        header="CPU"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_ramsize'}
                                        header="RAM"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_disksize'}
                                        header="DISK"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'usr_user__user_username'}
                                        header="Talepte Bulunan"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        header="Kontrol Eden"
                                        body={getController}
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        header="Talepte Bulunanın Kurumu"
                                        body={getInstBody}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />

                                    {/*<Column*/}
                                    {/*    field={'resv_reason'}*/}
                                    {/*    header="Rezervasyon Açıklaması"*/}
                                    {/*    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}*/}

                                    {/*>*/}

                                    {/*</Column>*/}
                                    <Column
                                        field={'resv_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Süresi Dolmuş Rezervasyonlar">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={expiredReservations}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'resv_id'}
                                        header="No"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        body={actionTemplate3}
                                        header="Onay Durumu"
                                        style={{textAlign: 'center', width: '9.5em'}}

                                    />

                                    <Column
                                        field={'flav__flav_name'}
                                        header="Şablon Adı"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_gpucount'}
                                        header="GPU"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_cpucount'}
                                        header="CPU"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_ramsize'}
                                        header="RAM"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'flav__flav_disksize'}
                                        header="DISK"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'usr_user__user_username'}
                                        header="Talepte Bulunan"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />

                                    <Column
                                        header="Kontrol Eden"
                                        body={getController}
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        header="Talepte Bulunanın Kurumu"
                                        body={getInstBody}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />

                                    {/*<Column*/}
                                    {/*    field={'resv_reason'}*/}
                                    {/*    header="Rezervasyon Açıklaması"*/}
                                    {/*    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}*/}

                                    {/*>*/}

                                    {/*</Column>*/}
                                    <Column
                                        field={'resv_reservationtime'}
                                        header="Oluşturulma Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_starttime'}
                                        header="Başlangıç Tarihi"
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>
                                    <Column
                                        field={'resv_finishtime'}
                                        header="Bitiş Tarihi"
                                        style={{textAlign: 'center', width: '5.5em'}}

                                    >

                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Reservation);


// WEBPACK FOOTER //
// ./src/pages/systemmanagement/Reservations.jsx